import { render, staticRenderFns } from "./SnapshotMenu.vue?vue&type=template&id=5f2e826d&"
import script from "./SnapshotMenu.vue?vue&type=script&lang=js&"
export * from "./SnapshotMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports